export default __webpack_public_path__ + "static/media/tooltip.7e9bf446.svg";